export const siteName = "SureQuran";

export const prodUrl = "https://www.surequran.com";
export const devUrl = "https://dev.surequran.com";

export const downloadsBaseUrl = "https://data.surequran.com/downloads/";

export const fontScalings = [200, 170, 135, 120, 110, 100, 95, 90, 85];
export const topAppBarHeight = 60;
export const appBarColor = "#115293";
export const iconColor = "#e8e8e8";
export const playPauseIconColor = "#FFC107";
export const blueUrlColor = "#1967d2";
export const defaultQuranFontSize = 1.1; // in rem
